export const AssetLocationTypeTranslation: { [key: number]: string } = {
  1: $localize`General`,
  2: $localize`Clean`,
  3: $localize`Soiled`,
  4: $localize`Storage`,
  5: $localize`Patient Room`,
};
